import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'

import { handleSubmitResult } from 'actions/form'
import { showSuccess, showError } from 'actions/Error'
import { confirmModal } from 'actions/ui'
import {
  biGHSVerifyList, biGHSUploadList,
  biNutritionalData999VerifyList, biNutritionalData999UploadList
} from 'actions/bi_import'

import AdminCommonFormLayout from '../layout/AdminCommonFormLayout'
import { FormikGeneralFormErrors } from 'components/form/GeneralFormErrors'
import AdminBIImportForm from './form/AdminBIImportForm'
import ConfirmationModal from 'components/ConfirmationModal'

const validationSchema = Yup.object().shape({
  bi_import_file: Yup.mixed().test(
    'file-required',
    'Required',
    value => value != null
  ),
  table_name: Yup.string().required("Required"),
})

const TABLE_CONFIG = {
  ghs: {
    verifyList: biGHSVerifyList,
    uploadList: biGHSUploadList,
  },
  nutritional_data_999: {
    verifyList: biNutritionalData999VerifyList,
    uploadList: biNutritionalData999UploadList,
  },
}

export default function AdminBIImport(props) {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const initial_values = { bi_import_file: null, table_name: 'ghs' }
  const breadcrumbs = [
    { name: 'admin_home' }, { name: 'bi_import', label: 'BI Import', url: '/admin/bi_import' }
  ]
  const table_name_options = [
    { label: 'GHS', value: 'ghs' }, { label: 'Nutritional Data 999', value: 'nutritional_data_999' }
  ]

  const onSave = (values, formik_funcs) => {
    setIsLoading(true)
    const config = TABLE_CONFIG[values?.table_name]
    if (!config) {
      console.log('Unknown table selected')
      setIsLoading(false)
      return
    }

    dispatch(config.verifyList.verify(values?.bi_import_file.id)).then((res) => {
      setIsLoading(false)
      const on_ok = () => {
        const onConfirmed = () => {
          setIsLoading(true)
          dispatch(config.uploadList.upload(values?.bi_import_file.id)).then((res) => {
            if (res?.status === "success") {
              showSuccess("Data successfully imported")
            } else {
              showError("Data could not be imported")
            }
            setIsLoading(false)
          })
        }
        dispatch(confirmModal({
          text: res.msg,
          onConfirmed,
          can_cancel: true
        }))
      }
      handleSubmitResult({res, formik_funcs, on_ok})
    })
  }

  return (
    <AdminCommonFormLayout
      breadcrumbs={ breadcrumbs }
      title="BI Import"
      initial_values={ initial_values }
      onSave={ onSave }
      save_label="Verify"
      validationSchema={ validationSchema }
      is_busy={ isLoading }
    >
      {({formik_props}) =>
        <>
      <AdminBIImportForm
        formik_props={ formik_props }
        table_name_options={ table_name_options }
      />
      <ConfirmationModal /> 
        </>
      }
    </AdminCommonFormLayout>
  )
}
